import {ClientUserReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableActionsEnum,
    ReportTableConfigInterface,
    ReportTableButtonTypesEnum,
    ReportTableActionMenuTypesEnum
} from '../../../app/shared/components';

export const PanelClientsEditTwoFactorDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: ClientUserReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getTwoFactorEnabledSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const ClientsEditTwoFactorDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'User',
            selector: ClientUserReportModel.getNameSelector()
        }),
        new ReportTableColumn({
            label: 'Status',
            selector: ClientUserReportModel.getTwoFactorEnabledSelector()
        })
    ],
    hiddenColumnIds: [],
    actionMenu: true,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: [
        {
            buttonType: ReportTableButtonTypesEnum.Reset,
            action: ReportTableActionsEnum.Reset
        }
    ]
};
